// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Notification System Styles */
.notification-container {
  position: fixed;
  top: var(--space-4);
  right: var(--space-4);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 400px;
  width: 100%;
  pointer-events: none;
}

.notification {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  box-shadow: 
    var(--shadow-xl),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  border-left: 4px solid var(--neutral-300);
  overflow: hidden;
  transform: translateX(100%);
  opacity: 0;
  transition: all var(--transition-normal);
  pointer-events: auto;
  position: relative;
}

.notification.visible {
  transform: translateX(0);
  opacity: 1;
}

.notification.exiting {
  transform: translateX(100%);
  opacity: 0;
}

/* Notification Types */
.notification.success {
  border-left-color: var(--success-500);
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);
}

.notification.error {
  border-left-color: var(--error-500);
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);
}

.notification.warning {
  border-left-color: var(--warning-500);
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);
}

.notification.info {
  border-left-color: var(--info-500);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);
}

.notification.loading {
  border-left-color: var(--primary-500);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);
}

/* Notification Content */
.notification-content {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  position: relative;
}

.notification-icon {
  font-size: var(--text-xl);
  flex-shrink: 0;
  margin-top: var(--space-1);
}

.notification-body {
  flex: 1 1;
  min-width: 0;
}

.notification-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-2);
  gap: var(--space-2);
}

.notification-title {
  color: var(--neutral-800);
  font-size: var(--text-base);
  font-weight: var(--font-semibold);
  margin: 0;
  line-height: var(--leading-tight);
}

.status-code {
  background: var(--neutral-100);
  color: var(--neutral-600);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  font-family: var(--font-family-mono);
}

.notification-message {
  color: var(--neutral-700);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
  margin: 0 0 var(--space-3) 0;
  word-wrap: break-word;
}

/* Notification Details */
.notification-details {
  margin-top: var(--space-3);
}

.notification-details summary {
  color: var(--neutral-600);
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  cursor: pointer;
  padding: var(--space-2);
  background: var(--neutral-50);
  border-radius: var(--radius-md);
  border: 1px solid var(--neutral-200);
  transition: all var(--transition-normal);
}

.notification-details summary:hover {
  background: var(--neutral-100);
  border-color: var(--neutral-300);
}

.notification-details[open] summary {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: transparent;
}

.notification-details pre {
  background: var(--neutral-50);
  border: 1px solid var(--neutral-200);
  border-top: none;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  padding: var(--space-3);
  margin: 0;
  font-size: var(--text-xs);
  font-family: var(--font-family-mono);
  color: var(--neutral-700);
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Notification Actions */
.notification-actions {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-3);
  flex-wrap: wrap;
}

.action-btn {
  padding: var(--space-2) var(--space-3);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  cursor: pointer;
  transition: all var(--transition-normal);
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn.primary {
  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);
  color: white;
  box-shadow: var(--shadow-sm);
}

.action-btn.primary:hover {
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.action-btn.secondary {
  background: var(--neutral-100);
  color: var(--neutral-700);
  border: 1px solid var(--neutral-300);
}

.action-btn.secondary:hover {
  background: var(--neutral-200);
  color: var(--neutral-800);
}

.action-btn.danger {
  background: linear-gradient(135deg, var(--error-500) 0%, var(--error-600) 100%);
  color: white;
  box-shadow: var(--shadow-sm);
}

.action-btn.danger:hover {
  background: linear-gradient(135deg, var(--error-600) 0%, var(--error-700) 100%);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Close Button */
.notification-close {
  position: absolute;
  top: var(--space-2);
  right: var(--space-2);
  background: none;
  border: none;
  color: var(--neutral-400);
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  transition: all var(--transition-normal);
  line-height: 1;
}

.notification-close:hover {
  background: var(--neutral-100);
  color: var(--neutral-600);
}

/* Progress Bar */
.notification-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--neutral-200);
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-500) 0%, var(--primary-600) 100%);
  transition: width 0.1s linear;
  border-radius: 0 0 var(--radius-xl) var(--radius-xl);
}

.notification.success .progress-bar {
  background: linear-gradient(90deg, var(--success-500) 0%, var(--success-600) 100%);
}

.notification.error .progress-bar {
  background: linear-gradient(90deg, var(--error-500) 0%, var(--error-600) 100%);
}

.notification.warning .progress-bar {
  background: linear-gradient(90deg, var(--warning-500) 0%, var(--warning-600) 100%);
}

.notification.info .progress-bar {
  background: linear-gradient(90deg, var(--info-500) 0%, var(--info-600) 100%);
}

/* Clickable Notifications */
.notification.clickable {
  cursor: pointer;
}

.notification.clickable:hover {
  transform: translateX(-4px);
  box-shadow: 
    var(--shadow-2xl),
    0 0 0 1px rgba(255, 255, 255, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .notification-container {
    top: var(--space-2);
    right: var(--space-2);
    left: var(--space-2);
    max-width: none;
  }
  
  .notification {
    transform: translateY(-100%);
  }
  
  .notification.visible {
    transform: translateY(0);
  }
  
  .notification.exiting {
    transform: translateY(-100%);
  }
  
  .notification-content {
    padding: var(--space-3);
  }
  
  .notification-title {
    font-size: var(--text-sm);
  }
  
  .notification-message {
    font-size: var(--text-xs);
  }
  
  .notification-actions {
    flex-direction: column;
  }
  
  .action-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .notification-container {
    top: var(--space-1);
    right: var(--space-1);
    left: var(--space-1);
  }
  
  .notification-content {
    padding: var(--space-2);
    gap: var(--space-2);
  }
  
  .notification-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-1);
  }
  
  .status-code {
    align-self: flex-start;
  }
}

/* Animation for loading notifications */
.notification.loading .notification-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .notification {
    border: 2px solid var(--neutral-800);
    background: white;
  }
  
  .notification.success {
    border-color: var(--success-800);
  }
  
  .notification.error {
    border-color: var(--error-800);
  }
  
  .notification.warning {
    border-color: var(--warning-800);
  }
  
  .notification.info {
    border-color: var(--info-800);
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .notification {
    transition: opacity 0.3s ease;
  }
  
  .notification.visible,
  .notification.exiting {
    transform: none;
  }
  
  .notification.loading .notification-icon {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NotificationSystem.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B;;sCAEoC;EACpC,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,+FAA+F;AACjG;;AAEA;EACE,mCAAmC;EACnC,+FAA+F;AACjG;;AAEA;EACE,qCAAqC;EACrC,gGAAgG;AAClG;;AAEA;EACE,kCAAkC;EAClC,gGAAgG;AAClG;;AAEA;EACE,qCAAqC;EACrC,gGAAgG;AAClG;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,oDAAoD;EACpD,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+EAA+E;EAC/E,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,+EAA+E;EAC/E,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kFAAkF;EAClF,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wCAAwC;AACxC;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Enhanced Notification System Styles */\n.notification-container {\n  position: fixed;\n  top: var(--space-4);\n  right: var(--space-4);\n  z-index: var(--z-toast);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  max-width: 400px;\n  width: 100%;\n  pointer-events: none;\n}\n\n.notification {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-xl);\n  box-shadow: \n    var(--shadow-xl),\n    0 0 0 1px rgba(255, 255, 255, 0.2);\n  border-left: 4px solid var(--neutral-300);\n  overflow: hidden;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: all var(--transition-normal);\n  pointer-events: auto;\n  position: relative;\n}\n\n.notification.visible {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n.notification.exiting {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n/* Notification Types */\n.notification.success {\n  border-left-color: var(--success-500);\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);\n}\n\n.notification.error {\n  border-left-color: var(--error-500);\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);\n}\n\n.notification.warning {\n  border-left-color: var(--warning-500);\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);\n}\n\n.notification.info {\n  border-left-color: var(--info-500);\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);\n}\n\n.notification.loading {\n  border-left-color: var(--primary-500);\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%);\n}\n\n/* Notification Content */\n.notification-content {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  position: relative;\n}\n\n.notification-icon {\n  font-size: var(--text-xl);\n  flex-shrink: 0;\n  margin-top: var(--space-1);\n}\n\n.notification-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-2);\n  gap: var(--space-2);\n}\n\n.notification-title {\n  color: var(--neutral-800);\n  font-size: var(--text-base);\n  font-weight: var(--font-semibold);\n  margin: 0;\n  line-height: var(--leading-tight);\n}\n\n.status-code {\n  background: var(--neutral-100);\n  color: var(--neutral-600);\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-sm);\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  font-family: var(--font-family-mono);\n}\n\n.notification-message {\n  color: var(--neutral-700);\n  font-size: var(--text-sm);\n  line-height: var(--leading-relaxed);\n  margin: 0 0 var(--space-3) 0;\n  word-wrap: break-word;\n}\n\n/* Notification Details */\n.notification-details {\n  margin-top: var(--space-3);\n}\n\n.notification-details summary {\n  color: var(--neutral-600);\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  cursor: pointer;\n  padding: var(--space-2);\n  background: var(--neutral-50);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--neutral-200);\n  transition: all var(--transition-normal);\n}\n\n.notification-details summary:hover {\n  background: var(--neutral-100);\n  border-color: var(--neutral-300);\n}\n\n.notification-details[open] summary {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-color: transparent;\n}\n\n.notification-details pre {\n  background: var(--neutral-50);\n  border: 1px solid var(--neutral-200);\n  border-top: none;\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n  padding: var(--space-3);\n  margin: 0;\n  font-size: var(--text-xs);\n  font-family: var(--font-family-mono);\n  color: var(--neutral-700);\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Notification Actions */\n.notification-actions {\n  display: flex;\n  gap: var(--space-2);\n  margin-top: var(--space-3);\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  padding: var(--space-2) var(--space-3);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  min-height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-btn.primary {\n  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.action-btn.primary:hover {\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.action-btn.secondary {\n  background: var(--neutral-100);\n  color: var(--neutral-700);\n  border: 1px solid var(--neutral-300);\n}\n\n.action-btn.secondary:hover {\n  background: var(--neutral-200);\n  color: var(--neutral-800);\n}\n\n.action-btn.danger {\n  background: linear-gradient(135deg, var(--error-500) 0%, var(--error-600) 100%);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.action-btn.danger:hover {\n  background: linear-gradient(135deg, var(--error-600) 0%, var(--error-700) 100%);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Close Button */\n.notification-close {\n  position: absolute;\n  top: var(--space-2);\n  right: var(--space-2);\n  background: none;\n  border: none;\n  color: var(--neutral-400);\n  font-size: var(--text-lg);\n  font-weight: var(--font-bold);\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-normal);\n  line-height: 1;\n}\n\n.notification-close:hover {\n  background: var(--neutral-100);\n  color: var(--neutral-600);\n}\n\n/* Progress Bar */\n.notification-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--neutral-200);\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  transition: width 0.1s linear;\n  border-radius: 0 0 var(--radius-xl) var(--radius-xl);\n}\n\n.notification.success .progress-bar {\n  background: linear-gradient(90deg, var(--success-500) 0%, var(--success-600) 100%);\n}\n\n.notification.error .progress-bar {\n  background: linear-gradient(90deg, var(--error-500) 0%, var(--error-600) 100%);\n}\n\n.notification.warning .progress-bar {\n  background: linear-gradient(90deg, var(--warning-500) 0%, var(--warning-600) 100%);\n}\n\n.notification.info .progress-bar {\n  background: linear-gradient(90deg, var(--info-500) 0%, var(--info-600) 100%);\n}\n\n/* Clickable Notifications */\n.notification.clickable {\n  cursor: pointer;\n}\n\n.notification.clickable:hover {\n  transform: translateX(-4px);\n  box-shadow: \n    var(--shadow-2xl),\n    0 0 0 1px rgba(255, 255, 255, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .notification-container {\n    top: var(--space-2);\n    right: var(--space-2);\n    left: var(--space-2);\n    max-width: none;\n  }\n  \n  .notification {\n    transform: translateY(-100%);\n  }\n  \n  .notification.visible {\n    transform: translateY(0);\n  }\n  \n  .notification.exiting {\n    transform: translateY(-100%);\n  }\n  \n  .notification-content {\n    padding: var(--space-3);\n  }\n  \n  .notification-title {\n    font-size: var(--text-sm);\n  }\n  \n  .notification-message {\n    font-size: var(--text-xs);\n  }\n  \n  .notification-actions {\n    flex-direction: column;\n  }\n  \n  .action-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .notification-container {\n    top: var(--space-1);\n    right: var(--space-1);\n    left: var(--space-1);\n  }\n  \n  .notification-content {\n    padding: var(--space-2);\n    gap: var(--space-2);\n  }\n  \n  .notification-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-1);\n  }\n  \n  .status-code {\n    align-self: flex-start;\n  }\n}\n\n/* Animation for loading notifications */\n.notification.loading .notification-icon {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .notification {\n    border: 2px solid var(--neutral-800);\n    background: white;\n  }\n  \n  .notification.success {\n    border-color: var(--success-800);\n  }\n  \n  .notification.error {\n    border-color: var(--error-800);\n  }\n  \n  .notification.warning {\n    border-color: var(--warning-800);\n  }\n  \n  .notification.info {\n    border-color: var(--info-800);\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .notification {\n    transition: opacity 0.3s ease;\n  }\n  \n  .notification.visible,\n  .notification.exiting {\n    transform: none;\n  }\n  \n  .notification.loading .notification-icon {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
